
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-general-info-readonly',
    imports: [],
    templateUrl: './general-info-readonly.component.html',
    styleUrl: './general-info-readonly.component.scss'
})
export class GeneralInfoReadonlyComponent {

  @Input() generalInfo: any = null;

  hasPlacement(info: {
    floor?: unknown;
    room?: unknown;
    rack?: unknown;
    case?: unknown;
    shelf?: unknown;
  }): boolean {
    return info.floor != null
      || info.room != null
      || info.rack != null
      || info.case != null
      || info.shelf != null;
  }

}
